import React from "react";
import "components/page/page.scss";
import { ButtonNew as Button } from "components/buttonNew";
import MultipleActionDropdown, {
  IMultipleActionDropdownProps,
} from "components/multipleActionDropdown/MultipleActionDropdown";
import SplitButton, { ISplitButtonProps } from "components/splitButton/SplitButton";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export interface IPrimaryPageAction {
  action: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
  content: JSX.Element | string;
}

export interface ISecondaryPageAction {
  action: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
  content: JSX.Element | string;
}

export interface IMultipleActionDropdownPageAction {
  label: string;
  disabled?: boolean;
  dropdownProps: Omit<IMultipleActionDropdownProps, "children">;
}

export interface IActionDetails {
  icon: IconName;
  /**Add any optional icon props. Ex: spin or pulse for animations */
  iconProps?: Omit<FontAwesomeIconProps, "icon">;
  content: string;
  /**If this prop is passed, the action details text will be underlined. When hovered, a tooltip will be displayed with the content of this prop value*/
  toolTipContent?: string;
}

interface IPageActionsProps {
  primaryAction?: IPrimaryPageAction;
  secondaryActions?: ISecondaryPageAction[];
  multipleActionDropdownAction?: IMultipleActionDropdownPageAction;
  splitButtonAction: ISplitButtonProps;
  actionDetails?: IActionDetails;
}

function PageActions(props: IPageActionsProps) {
  const { primaryAction, secondaryActions, multipleActionDropdownAction, splitButtonAction, actionDetails } = props;

  return (
    <div className="ui-page-actions">
      {actionDetails &&
        //Show details with tool tip
        (actionDetails.toolTipContent ? (
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip id="leftMenuToolTip">{actionDetails?.toolTipContent}</Tooltip>}
          >
            <div className="ui-page-actions-details-container ui-page-actions-details-container-tooltip">
              <FontAwesomeIcon
                className={"ui-pages-action-details"}
                size="1x"
                icon={["far", actionDetails.icon]}
                {...actionDetails?.iconProps}
              />
              <p className="ui-pages-action-details">{actionDetails.content}</p>
            </div>
          </OverlayTrigger>
        ) : (
          //Display details without tool tip
          <div className="ui-page-actions-details-container">
            <FontAwesomeIcon
              className="ui-pages-action-details"
              size="1x"
              icon={["far", actionDetails.icon]}
              {...actionDetails?.iconProps}
            />
            <p className="ui-pages-action-details">{actionDetails.content}</p>
          </div>
        ))}
      {multipleActionDropdownAction && (
        <MultipleActionDropdown
          {...multipleActionDropdownAction.dropdownProps}
          disabled={multipleActionDropdownAction.disabled}
        >
          <Button size="medium" type="secondary" disabled={!!multipleActionDropdownAction?.disabled}>
            {multipleActionDropdownAction.label}
          </Button>
        </MultipleActionDropdown>
      )}
      {secondaryActions?.map((item: ISecondaryPageAction, index: number) => (
        <Button key={index} onClick={item.action} disabled={!!item.disabled}>
          {item.content}
        </Button>
      ))}
      {splitButtonAction && <SplitButton {...splitButtonAction}></SplitButton>}
      {primaryAction && (
        <Button size="medium" type="primary" disabled={!!primaryAction.disabled} onClick={primaryAction.action}>
          {primaryAction.content}
        </Button>
      )}
    </div>
  );
}

export default PageActions;
